/* global ENDPOINT_URL */
/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "CloudDataConnector" }] */
'use strict'

export default class CloudDataConnector {
  constructor () {
    // Globally provided
    this.endpoint = ENDPOINT_URL
  }

  async getEquipments (filters) {
    return this.getPaginated('/actors-network/equipments', filters)
  }

  async getStudies (filters) {
    return this.getPaginated('/actors-network/studies', filters)
  }

  async getBotanicalReports () {
    return this.getPaginated('/botanical-reports')
  }

  async getGreeneryYearly (station) {
    return this.getPaginated('/greenery/yearly/' + station, {})
  }

  async getGreeneryDaily (station) {
    return this.getPaginated('/greenery/daily/' + station, {})
  }

  async getFrogsAnnualMeanLaying (station) {
    return this.getPaginated('/frogs/annualMeanLaying/' + station, {})
  }

  async getSnow (station) {
    return this.getPaginated('/temperatures/' + station + '/snow', {})
  }

  async getFrost (station) {
    return this.getPaginated('/temperatures/' + station + '/frost', {})
  }

  async getSeasonMeanTemperatures (station, season) {
    return this.getPaginated('/temperatures/' + station + '/seasonMean/' + season.toLowerCase(), {})
  }

  async getSeasonNormalTemperatures (station, season) {
    return this.getPaginated('/temperatures/' + station + '/seasonNormal/' + season.toLowerCase(), {})
  }

  async getPaginated (urlPart, filters) {
    const that = this
    let result = []
    let response = {}
    do {
      response = await $.ajax({
        url: that.endpoint + urlPart,
        data: {
          ...filters,
          next: response.next
        }
      })
    } while (response.next)
    result = result.concat(response.data)
    return result
  }
}
